var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-6 col-md-7 col-xl-5"},[_c('a-card',[_c('ChangePasswordForm')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }